<template>
  <section class="negocieApp">
    <toaster />
    <header>
      <div>
        <router-link :to="{ name: 'negociejaApp' }" class="btVoltar" v-if="inner && currentUser">
          <fa :icon="['far', 'arrow-left']" />
        </router-link>
      </div>
      <div>
        <logo size="40px" />
      </div>
    </header>
    <spinner v-if="!acessoValidado" />
    <inner-page :state="inner" :session="session" :step="step" :steps="steps" :msg="msg" v-else-if="inner && !acessoBloqueado">
      <negociar v-if="session == 'negociar'" :session="session" :step="step" :steps="steps" :debitos="debitos" :idProposta="idProposta"/>
    </inner-page>
    <main v-else-if="acessoValidado">
      <div class="intro">
        <h3 v-if="currentUser">Olá {{ nome(currentUser.nome) }}</h3>
        <p>Seja bem vindo ao <b>Negocie Já</b>. <br/>Aqui você quita seus débitos com a Rede Decisão <br>de forma rápida e sem complicação.</p>  
    </div>
      <home-banner
        :pendencias="pendencias"
        :bloqueado="acessoBloqueado"
        :mensagem-bloqueio="mensagemBloqueio"
      />
      <home-dash />
    </main>
    <nav-menu />
    <div v-if="showBloqueioModal" class="bloqueio-backdrop" role="presentation">
      <div
        ref="bloqueioModal"
        class="bloqueio-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bloqueio-modal-title"
        aria-describedby="bloqueio-modal-description"
        @keydown.esc="closeBloqueioModal"
        @keydown.tab.prevent="focusBloqueioModal"
      >
        <h5 id="bloqueio-modal-title">{{ tituloBloqueio }}</h5>
        <p id="bloqueio-modal-description">{{ mensagemBloqueio }}</p>
        <button ref="bloqueioModalButton" type="button" class="btn btn-primary" @click="closeBloqueioModal">
          Entendi
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Logo from '@/components/template/logo.vue'
import HomeDash from '@/components/financeiro/negocieja/app/utilities/HomeDash.vue'
import NavMenu from '@/components/financeiro/negocieja/app/navigation/NavMenu.vue'
import HomeBanner from '@/components/financeiro/negocieja/app/utilities/HomeBanner.vue'
import InnerPage from '@/components/financeiro/negocieja/app/template/InnerPage.vue'
import Negociar from '@/components/financeiro/negocieja/app/template/Negociar.vue'
import Spinner from '@/components/financeiro/negocieja/app/utilities/Spinner.vue'
// import FinanceiroService from '@/services/financeiro.service.js'
import NegociaService from '@/services/negocieja.service.js'

export default {
  components: {
    Logo, HomeDash, NavMenu, HomeBanner, InnerPage, Negociar, Spinner
  },
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    },
    idProposta: {
      type: [String, Number]
    }
  },
  watch: {
    session ( value ) {
      if (!this.acessoValidado) return

      if (this.acessoBloqueado && value) {
        this.showBloqueioModal = true
        this.focusBloqueioModal()
        this.$router.replace({ name: 'negociejaApp' })
        return
      }

      if ( value ) {
        this.inner = true
      } else {
        this.inner = false
      }
    }
  },
  data () {
    return {
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      range: {
        inicio: '2022-01-01',
        fim: '2025-12-01',
      },
      pendencias: false,
      inner: false,
      current: 0,
      msg: null,
      loading: true,
      debitos: null,
      acessoValidado: false,
      acessoBloqueado: false,
      showBloqueioModal: false,
      tituloBloqueio: '',
      mensagemBloqueio: '',
      steps: [
         {
          slug: 'debitos',
          title: 'Débitos'  
        },
        {
          slug: 'pagamento',
          title: 'Pagamento'  
        },
        {
          slug: 'parcelas',
          title: 'Parcelas'  
        },
        {
          slug: 'termo',
          title: 'Termo'  
        },
        {
          slug: 'checkout',
          title: 'Checkout'  
        },
        {
          slug: 'final',
          title: 'Final'
        }
      ]
    }
  },
  async mounted () {
    if (this.$route.name === 'negociejaApp') {
      await this.checkBloqueioNegociacao()
    }

    this.acessoValidado = true

    if (this.acessoBloqueado) {
      if (this.session) {
        await this.$router.replace({ name: 'negociejaApp' })
      }

      this.showBloqueioModal = true
      this.focusBloqueioModal()
      return
    }

    if ( this.session ) {
      this.inner = true

      if ( this.step == 'debitos' ) {
        this.getDebitosLocais()
      }
    } else {
      this.inner = false
      this.getDebitos()
    }
  },
  methods: {
    async checkBloqueioNegociacao () {
      const idPessoa = this.currentUser?.idPessoa

      if (!idPessoa) {
        this.blockAccess(
          'Acesso indisponível',
          'Não foi possível identificar o responsável financeiro para validar a negociação.'
        )
        return
      }

      try {
        const response = await NegociaService.getBloqueioNegociacao(idPessoa)
        const bloqueios = Array.isArray(response?.data?.data) ? response.data.data : []
        const possuiNegociacaoAtiva = bloqueios.some(bloqueio =>
          Number(bloqueio.idmotivoBloqueio) === 18 && Number(bloqueio.cancelado) === 0
        )

        if (possuiNegociacaoAtiva) {
          this.blockAccess(
            'Negociação em andamento',
            'Você já possui uma negociação ativa. Não é possível realizar outra até finalizar a negociação existente.'
          )
        }
      } catch (error) {
        console.error('Erro ao validar bloqueio de negociação', error)
        this.blockAccess(
          'Acesso indisponível',
          'Não foi possível validar sua negociação neste momento. Tente novamente mais tarde.'
        )
      }
    },
    blockAccess (titulo, mensagem) {
      this.acessoBloqueado = true
      this.tituloBloqueio = titulo
      this.mensagemBloqueio = mensagem
    },
    closeBloqueioModal () {
      this.showBloqueioModal = false
    },
    focusBloqueioModal () {
      this.$nextTick(() => {
        this.$refs.bloqueioModalButton?.focus()
      })
    },
    dropMessage ( value ) {
      this.msg = value
    },
    // getFicha () {
    //   // const idPessoa = 564966
    //   const idPessoa = this.currentUser.idPessoa
    //   // console.log("idPessoa:", this.currentUser)
      
    //   const options = {
    //     idPessoa: idPessoa,
    //     ...this.range
    //   }

    //   FinanceiroService.getFichaFinanceira(options).then(
    //     response => {
    //       if ( response.data.length > 0 ) {
    //         this.parseData(response.data)
    //       }
    //     },
    //     error => {
    //       console.error(error)
    //       window.spinner.emit('close')
    //     }
    //   )
    // },
    getDebitosLocais () {
      const data = localStorage.getItem('negociacaoDados')
      const debitos = JSON.parse(data)

      this.calculaDebitos(debitos.mencodigos,debitos.mencodigos)
      // console.log("debitos:", debitos)
    },  
    getDebitos () {
      const idPessoa = this.currentUser.idPessoa

      NegociaService.getDebitosResp(idPessoa).then(
        response => {
          this.pendencias = response.data.length > 0

          if ( this.pendencias ) {
            const mencodigos = response.data.map( k => k.mencodigo )
            this.calculaDebitos(mencodigos, response.data)
          }
          console.log("response:", response.data)
        }
      ).catch( error => {
        console.error(error)
      })
    },
    parseData ( data ) {
      const atrasados = data.filter( a => a.situacao == 'Atrasado' )

      const mencodigos = atrasados.map( k => k.mencodigo )
      // console.log('mencodigos:', mencodigos)
      this.pendencias = mencodigos.length > 0
      // console.log('pendencias:', this.pendencias)

      if ( this.pendencias ) {
        this.calculaDebitos(mencodigos, mencodigos)
      }
      
    },
    calculaDebitos ( mencodigos, src ) {
      const data = {
        cpf_responsavel_financeiro: this.currentUser.cadastro.Documento.cpf,
        mencodigos: mencodigos
      }
      NegociaService.getDebitos( data ).then(response => {
        console.log('getDebitos:', response.data)
        const debitos = response.data
        const mensalidadesMatriculas = debitos.mensalidadesMatriculas

        const uniqueMatcodigos = [...new Set(mensalidadesMatriculas.map(item => item.matcodigo))]
        const totalMatriculas = uniqueMatcodigos.length
        
        const msgContent = {
          totalMatriculas,
          totalMensalidades: mensalidadesMatriculas.length
        }
        this.createMsg(msgContent)
        const valores_corrigidos = src.map( k => { return { mencodigo: k.mencodigo, valor_corrigido: k.valor_corrigido } })

        this.debitos = {
          ...debitos,
          mencodigos,
          valores_corrigidos,
          cpf_responsavel_financeiro: this.currentUser.cadastro.Documento.cpf
        }
      }).catch( error => {
        console.error(error)
      })
    },
    createMsg ( options ) {
      const { totalMensalidades, totalMatriculas } = options
      this.msg = `${totalMensalidades} parcela${totalMensalidades > 1 ? 's' : ''} em aberto, em ${totalMatriculas} matrícula${totalMatriculas > 1 ? 's diferentes' : ''}.`
    },
    nome ( nome ) {
      return nome.split(" ")[0].toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
  .negocieApp {
    display: block;
    width: 100%; height: 100vh;
    // overflow-y: auto;
    overflow: hidden;
    background-image: 
      url('@/assets/img/app_negocie_bg.png'),
      radial-gradient(circle at top left, #6b70ec, #666be9, #6266e6, #5d61e3, #585ce0, #5557de, #5353db, #504ed9, #4f48d7, #4f42d4, #4e3cd2, #4e35cf);
    background-repeat: no-repeat, no-repeat;
    background-position: top right, top left;
    background-size: auto, cover;
    color: $color-secondary;
    max-width: 1024px;
    margin: auto;
    box-shadow: -3px 3px 24px rgba(79, 84, 219, 0.5);
    position: relative;

    @media screen and ( min-width: 1024px ) {
      border-radius: $border-radius-large;
      max-height: calc(100vh - 60px);
      margin-top: 30px;
    }

    > header {
      display: flex; width: 100%;
      padding: $hmg_large;
      position: relative;
      z-index: 102;

      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }
      
      .btVoltar {
        width: 40px; height: 40px;
        border: 2px solid $color-secondary;
        font-size: 18px;
        display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        line-height: 1;
        border-radius: 16px;
        color: $azul-escuro;
        background-color: #F4F6FB;
      }

      >div {
        flex: 1;

        &:last-child {
          display: flex; justify-content: flex-end;
        }
      }
    }

    main {
      padding: 0 $hmg_large $hmg_large;

      .intro {
        padding: $hmg_mid;

        @media screen and (max-height: 689px) {
          padding-top: 0;

          br {
            display: none;
          }
        }

        p {
          margin: 0;
        }
        h3 {
          text-transform: capitalize;
        }
      }
    }

    .bloqueio-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, .6);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: $hmg_mid;
      z-index: 999;
    }

    .bloqueio-modal {
      background: $color-secondary;
      color: $preto-2;
      border-radius: $border-radius-mid;
      padding: $hmg_large;
      max-width: 420px;
      width: 100%;
      box-shadow: 0 8px 24px rgba(0, 0, 0, .25);

      h5 {
        margin-top: 0;
        margin-bottom: $hmg_small;
      }

      p {
        margin-bottom: $hmg_mid;
      }

      button {
        min-height: 44px;
        width: 100%;
      }
    }
  }
</style>
